import EA from '../helpers/init';


export default EA.Methods.popupController = ($this) => {
    // Config
    const popupButtonSelector = '.popup-button';
    const popupCloseButtonSelector = '.popup-close-button';

    const popupActiveClass = 'popup-active';
    const pagehasOpenPopupClass = 'popup-open';


    // State
    const openPopups = [];


    // Queries
    const popupButtons = document.querySelectorAll(popupButtonSelector);
    const popupCloseButtons = document.querySelectorAll(popupCloseButtonSelector);


    // Main
    addEventListenersToPopupButtons();
    addEventListenersToPopupCloseButtons();


    // Events
    document.body.addEventListener('close-popup', (event) => {
        let popupID = event.detail?.popupID;
        popupID = popupID.replace('#', '');

        if (popupID) {
            closePopup(popupID);
        } else {
            console.log('No popup ID found for the close-popup event.');
        }
    });


    // Functions
    function addEventListenersToPopupButtons() {
        popupButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                let popupID = button.getAttribute('data-popup-id') || button.getAttribute('href') || '';
                popupID = popupID.replace('#', '');
                
                if (popupID) {
                    openPopup(popupID);
                } else {
                    console.log('No popup ID found for the clicked button.');
                }
            });
        });
    }

    function addEventListenersToPopupCloseButtons() {
        popupCloseButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                let popupID = button.getAttribute('data-popup-id') || button.getAttribute('href') || '';
                popupID = popupID.replace('#', '');

                if (popupID) {
                    closePopup(popupID);
                } else {
                    console.log('No popup ID found for the clicked close button.');
                }
            });
        });
    }

    function openPopup(popupID) {
        const popup = document.getElementById(popupID);

        if (openPopups.length) {
            console.log('Another popup is already open.');
            return;
        }

        if (popup) {
            popup.classList.add(popupActiveClass);
            openPopups.push(popupID);
            dispatchOpenedPopupEvent(popupID);

            // Check for keyboard dismiss key
            const allowKeyboardDismiss = popup.getAttribute('data-allow-keyboard-dismiss');
            if (allowKeyboardDismiss) {
                const keydownHandler = (event) => {
                    // Check 'Escape' key and check if that popupId is even open anymore
                    if ((event.key === 'Escape') || !openPopups.includes(popupID)) {
                        closePopup(popupID);
                        document.removeEventListener('keydown', keydownHandler);
                    }
                };
                document.addEventListener('keydown', keydownHandler);
            }

            // Lock the body scroll and indicate that a popup is open
            document.body.classList.add(pagehasOpenPopupClass);
            document.body.style.overflow = 'hidden';
        }
        else {
            console.log('Popup by ID: ' + popupID + ' not found.');
        }
    }

    function closePopup(popupID) {
        const popup = document.getElementById(popupID);

        if (popup) {
            popup.classList.remove(popupActiveClass);
            const index = openPopups.indexOf(popupID);

            if (index > -1) {
                openPopups.splice(index, 1);
                dispatchClosePopupEvent(popupID);
            }

            // Clearing all popup-related states and styles when no popups are open
            if (openPopups.length === 0) {
                document.body.classList.remove(pagehasOpenPopupClass);
                document.body.style.overflow = '';
            }
        }
        else {
            console.log('Popup by ID: ' + popupID + ' not found.');
        }
    }


    // Helpers
    function dispatchOpenedPopupEvent(popupID) {
        const event = new CustomEvent('opened-popup', {
            detail: {
                popupID: popupID
            }
        });
        document.body.dispatchEvent(event);
    }

    function dispatchClosePopupEvent(popupID) {
        const event = new CustomEvent('closed-popup', {
            detail: {
                popupID: popupID
            }
        });
        document.body.dispatchEvent(event);
    }
};
